import { Stack, Typography } from '@mui/material'
import { com } from '@eidu/web'
import { useSortedEntityTypes } from '../../io/useEntityTypes'
import useSemanticLinks from '../../io/useSemanticLinks'
import EntityTypesStack from '../../components/layout/EntityTypesStack'
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink

type SemanticsPageContentProps = {
  entityTypes: readonly EntityType[]
  semanticLinks: readonly SemanticLink[]
}

const SemanticsPageContent = ({ entityTypes, semanticLinks }: SemanticsPageContentProps) => (
  <Stack paddingX={3} paddingY={3} spacing={3}>
    <Typography variant="h4">Semantics</Typography>
    <EntityTypesStack kind={EntityTypeKind.Companion.School} entityTypes={entityTypes} semanticLinks={semanticLinks} />
    <EntityTypesStack kind={EntityTypeKind.Companion.User} entityTypes={entityTypes} semanticLinks={semanticLinks} />
  </Stack>
)

const SemanticsPage = () => {
  const entityTypes = useSortedEntityTypes() ?? []
  const { semanticLinks } = useSemanticLinks()

  return <SemanticsPageContent entityTypes={entityTypes} semanticLinks={semanticLinks ?? []} />
}

export default SemanticsPage

export { SemanticsPageContent }
